<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="员工姓名">
              <j-search-select-tag type="list" v-model="queryParam.username" dict="sys_user,realname,username,del_flag=0" placeholder="请选择用户"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="工资日期">
              <j-dict-select-tag type="list"v-model="queryParam.signStatus" dictCode="sign_status" placeholder="请选择工资日期"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('员工薪酬')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <hRSalary-modal ref="modalForm" @ok="modalFormOk"></hRSalary-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import HRSalaryModal from './modules/HRSalaryModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { mixinDevice } from '@/utils/mixin'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"
  import {getAction} from '@/api/manage'
  import {frozenBatch} from '@/api/api'

  export default {
    name: "HRSalaryList",
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      HRSalaryModal,
      JDictSelectTag,
      JSearchSelectTag
    },
    data () {
      return {
        description: '员工薪酬管理页面',
        entryTimeRange:[],
        queryParam:{
          userId:'',
          cardNo:'',
          signStatus:'',
          education:'',
          entryTime_begin:'', //入职时间起始日期时间
          entryTime_end:'',
          practiceNo:''
        },

        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
           },
		      {
            title: '工资日期',
            align:"center",
            dataIndex: 'salaryDate'
           },
		      {
            title: '员工姓名',
            align:"center",
            dataIndex: 'username_dictText'
           },
		      {
            title: '基本工资',
            align:"center",
            dataIndex: 'salaryBase'
           },
		      {
            title: '岗位工资',
            align:"center",
            dataIndex: 'salaryPost'
           },
		      {
            title: '绩效工资',
            align:"center",
            dataIndex: 'salaryPrp'
           },
		      {
            title: '补贴-交通',
            className:"column-text",
            dataIndex: 'salaryPerkTraffic'
           },
		      {
            title: '补贴-午餐',
            className:"column-text",
            dataIndex: 'salaryPerkLunch'
           },
		      {
            title: '补贴-通讯',
            align:"center",
            dataIndex: 'salaryPerkTel'
           },
		      {
            title: '补贴-合计',
            align:"center",
            dataIndex: 'salaryPerkCount'
           },
		      {
            title: '薪酬合计',
            align:"center",
            dataIndex: 'salaryCount'
           },
		      {
            title: '考勤',
            align:"center",
            dataIndex: 'sign'
           },
		      {
            title: '社保-养老保险',
            align:"center",
            dataIndex: 'socialEndowment'
           },
		      {
            title: '社保-失业保险',
            align:"center",
            dataIndex: 'socialUnemployment'
           },
		      {
            title: '社保-医疗保险',
            align:"center",
            dataIndex: 'socialMedical'
           },
		      {
            title: '社保-住房公积金',
            align:"center",
            dataIndex: 'socialHousing'
           },
		      {
            title: '社保-合计',
            align:"center",
            dataIndex: 'socialCount'
           },
		      {
            title: '个人所得税',
            align:"center",
            dataIndex: 'rate'
           },
		      {
            title: '实发工资',
            className:"column-text",
            dataIndex: 'netSalary'
           },
		      {
            title: '实发比例',
            className:"column-text",
            dataIndex: 'netRate'
           },
		      {
            title: '发放金额',
            className:"column-text",
            dataIndex: 'netFact'
           },
        ],
		    url: {
          list: "/hr/hRSalary/list",
          delete: "/hr/hRSalary/delete",
          deleteBatch: "/hr/hRSalary/deleteBatch",
          exportXlsUrl: "hr/hRSalary/exportXls",
          importExcelUrl: "hr/hRSalary/importExcel",
          changeSignStatus: 'hr/hRSalary/changeSignStatus',
       },
    }
  },
  computed: {
    importExcelUrl: function(){
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
    methods: {
      onDateChange: function (value, dateString) {
        this.entryTimeRange = dateString;
      },
      getQueryParams() {
        if(this.entryTimeRange.length >=2){
          this.queryParam.entryTime_begin = this.entryTimeRange[0] + ' 00:00:00';
          this.queryParam.entryTime_end = this.entryTimeRange[1] + ' 23:59:59';
        }
        this.queryParam.field = this.getQueryField()
        this.queryParam.pageNo = this.ipagination.current
        this.queryParam.pageSize = this.ipagination.pageSize
        return this.queryParam;
      },

      changeSignStatus(record){
        //解约后台同时冻结登录账号
        const SYSUSER_STATUS_FROZENED = 2; //冻结状态为2
        let that = this;
        let param = {id:record.id,userId:record.userId};
        getAction(this.url.changeSignStatus, param).then((res)=>{
          if(res.success){
            frozenBatch({ids: record.userId, status: SYSUSER_STATUS_FROZENED}).then((res2) => {
              if (res2.success) {
                that.$message.info("解约成功，登录账号已冻结")
                that.loadData();
              } else {
                that.$message.warning("解约成功，但冻结账号失败，请到用户管理功能中进行冻结");
              }
            })
          } else{
            that.$message.warning("解约失败")
          }
        })
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>